import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@/common/components/ui/table';
import { useFormatCurrency } from '@/common/hooks/useFormatCurrency';
import { useScroll } from '@/policy/hooks/useScroll';
import { Car } from '@/policy/types/PolicyCoverage';

import { isMainChapter } from '../../utils/cars';
import { ScrollShadows } from '../ScrollShadows/ScrollShadows';
import { CarSectionsTableHeader } from './CarSectionsTableHeader';

interface CarSectionsTableProps {
  car: Car;
}

export const CarSectionsTable = ({ car }: CarSectionsTableProps) => {
  const { formatCurrency } = useFormatCurrency();
  const { scrollContainerRef, dragProps, canScrollLeft, canScrollRight } =
    useScroll();

  const tryFormatCurrency = (value: string) => {
    if (!value) return '';
    if (value.endsWith('%') || !Number.parseFloat(value)) return value;
    return formatCurrency(value);
  };

  return (
    <ScrollShadows
      canScrollLeft={canScrollLeft}
      canScrollRight={canScrollRight}
    >
      <div
        ref={scrollContainerRef}
        {...dragProps}
        className={`w-full overflow-x-auto scrollbar-visible select-none ${dragProps.className}
        [&::-webkit-scrollbar]:h-1.5
        [&::-webkit-scrollbar-track]:bg-transparent
        [&::-webkit-scrollbar-thumb]:bg-warm-gray-400
        [&::-webkit-scrollbar-thumb]:rounded-full`}
      >
        <Table
          noWrapper
          className="min-w-max w-full"
          style={{ tableLayout: 'auto' }}
        >
          <CarSectionsTableHeader />
          <TableBody>
            {car.sections.map((section) => {
              const isMain = isMainChapter(section.warranties);
              return (
                <TableRow
                  key={section.identifier}
                  className="bg-white even:bg-white"
                >
                  <TableCell
                    className={`text-left border-r border-warm-gray-200 ${
                      isMain ? 'font-bold' : 'px-6'
                    }`}
                  >
                    {section.warranties}
                  </TableCell>
                  <TableCell className="text-right border-r border-warm-gray-200">
                    {tryFormatCurrency(section.coverageAmount)}
                  </TableCell>
                  <TableCell className="text-right border-r border-warm-gray-200">
                    {section.deductible}
                  </TableCell>
                  <TableCell className="text-right">
                    {tryFormatCurrency(section.premium)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </ScrollShadows>
  );
};
